define.alias("shared/components/shared/post/secondary/caption-writer/loader", "calendar/components/shared/post/secondary/caption-writer/loader");